var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrapper"},[_c('div',{staticClass:"pagination-left"},[_c('div',[_vm._v(_vm._s(_vm.entryText))])]),_c('nav',{staticClass:"pagination-nav"},[_c('div',{staticClass:"navigation-pane"},[_c('ul',{staticClass:"pagination mb-0"},[_c('li',{class:{ 'page-item': true, disabled: _vm.currentPage <= 1 }},[_c('a',{staticClass:"page-back",class:{ 'page-link': true, cursor: _vm.currentPage > 1 },on:{"click":function($event){return _vm.setPage($event, _vm.currentPage - 1)}}},[_vm._v("«")])]),_vm._l((_vm.shownPages),function(page){return _c('li',{key:page,staticClass:"page-item page",class:{
            active: page === _vm.currentPage
          }},[_c('a',{class:{
              'page-link': true,
              cursor: _vm.currentPage !== page
            },on:{"click":function($event){return _vm.setPage($event, page)}}},[_vm._v(_vm._s(page))])])}),_c('li',{class:{
            'page-item': true,
            disabled: _vm.currentPage >= _vm.maxPage
          }},[_c('a',{class:{
              'page-link': true,
              cursor: _vm.currentPage < _vm.maxPage
            },on:{"click":function($event){return _vm.setPage($event, _vm.currentPage + 1)}}},[_vm._v("»")])])],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }